import { render, staticRenderFns } from "./MessageContentRequestUserLocation.vue?vue&type=template&id=4d8ca14a&"
import script from "./MessageContentRequestUserLocation.vue?vue&type=script&lang=js&"
export * from "./MessageContentRequestUserLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports